export interface BaseResponseAttributes {
  code: number;
  message: string;
  data: string | null;
}

export enum LoadingStateAAttributes {
  initial = 1,
  progress,
  failure,
  success,
  data,
}
